<template>
  <div>
    <router-view />
    <ProFeatureModal
      v-if="authUserData"
      :is-modal-open="openProFeatureModal"
      :close-modal="() => (openProFeatureModal = false)"
      :go-to-pro="() => (openUpgradeProModal = true)"
    />
    <UpgradeProModal
      v-if="authUserData"
      :is-modal-open="openUpgradeProModal"
      :close-modal="() => (openUpgradeProModal = false)"
    />
  </div>
</template>

<script>
import { saveActionType } from "@/utils/utils";
import ProFeatureModal from "@/components/_shared/ProFeatureModal.vue";
import { mapGetters } from "vuex";
import UpgradeProModal from "@/components/_shared/UpgradeProModal.vue";

export default {
  name: "App",
  components: { UpgradeProModal, ProFeatureModal },
  data() {
    return {
      openProFeatureModal: false,
      openUpgradeProModal: false,
    };
  },
  computed: {
    ...mapGetters({
      isProVersion: "auth/isProVersion",
      authConfig: "auth/authConfig",
      authUserData: "auth/getAuthUserData",
    }),
  },
  beforeMount() {
    document.addEventListener("click", this.handleGlobalEvent, true);
    document.addEventListener("change", this.handleGlobalEvent, true);
    document.addEventListener("mousedown", this.handleGlobalEvent, true);
    document.addEventListener("pointerdown", this.handleGlobalEvent, true);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleGlobalEvent, true);
    document.removeEventListener("change", this.handleGlobalEvent, true);
    document.removeEventListener("mousedown", this.handleGlobalEvent, true);
    document.removeEventListener("pointerdown", this.handleGlobalEvent, true);
  },
  methods: {
    handleGlobalEvent(event) {
      const target = event.target.closest("[data-action-type]");
      if (target) {
        const actionType = target.getAttribute("data-action-type");
        saveActionType(actionType);
      }

      const feature = event.target.closest("[data-feature]");
      if (feature && !this.isProVersion) {
        const featureName = feature.getAttribute("data-feature");
        if (this.authConfig.proFeatures.includes(featureName)) {
          this.openProFeatureModal = true;
          event.preventDefault();
          event.stopPropagation();
        }
      }
    },
  },
};
</script>
